<div class="traffic-light-type">
  <i (click)="setOption(option)"
     *ngFor="let option of trafficLightOptions"
     [class.active]="formControl.value === option"
     class="fas fa-circle {{option}}">
  </i>
</div>
